import { ExpensesRootPageQuery } from 'generated/resources/graphql'

import { PayrollExpensableDetail } from 'modules/expenses/types/PayrollExpensableDetail'

export const usePayroll = (
  canReimburseThroughPayroll: boolean,
  compensationsEnabled?: boolean,
  data?: ExpensesRootPageQuery['payroll'],
  compensationsData?: ExpensesRootPageQuery['compensations']
): PayrollExpensableDetail => {
  if (compensationsEnabled && compensationsData) {
    const compensationsPeriod =
      compensationsData.currentCompensationsPayrollRunsConnection?.nodes?.[0]

    const reimbursableNodes = compensationsData.reimbursablePayrollConceptsConnection?.nodes || []
    const categories = reimbursableNodes
      .map((node) => {
        if (
          node.reimbursable &&
          'identifier' in node.reimbursable &&
          typeof node.reimbursable.identifier === 'string'
        ) {
          return node.reimbursable.identifier
        }
        return null
      })
      .filter((category): category is string => Boolean(category))

    return {
      categories,
      currentPeriodOpen: compensationsPeriod ? compensationsPeriod.openToCompensate : false,
    }
  }

  if (!canReimburseThroughPayroll || !data) {
    return {
      categories: [],
      currentPeriodOpen: false,
    }
  }

  const categories =
    data.expensesCategoriesContractsTaxonomiesConnection.nodes.map((t) => t.expensesCategoryId) ||
    []

  const currentPeriodOpen =
    data.currentDefaultPolicyPeriodsConnection?.nodes?.some((period) => period.openToSupplements) ||
    false

  return {
    categories,
    currentPeriodOpen,
  }
}
